import React from 'react'
import styled from 'styled-components'

import colors from 'styles/colors'
import text from 'styles/text'
import media from 'styles/media'

import links from 'utils/links'

const WatchNow: React.FC = () => {

  const handleClick = () => {
    window.open(links.home, 'blank')
  }

  return (
    <Wrapper onClick={handleClick}>

      <Content>
        Watch Now
      </Content>

      <SVG viewBox="0 0 150 45" fill="none">
        <Path d="M 0.5 0.5 H 135 L 149 15 V 43.5 H 15 L 0.5 30 Z"/>     
      </SVG>

    </Wrapper>
  )
}

export default WatchNow

const SVG = styled.svg`
  position: absolute;
  z-index: 1;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const Path = styled.path`
  stroke: ${colors.pureWhite};
  stroke-width: 1px;
  fill: rgba(0, 0, 0, 0.5);
  transition: 500ms;
`

const Content = styled.div`
  ${text.desktop.button}
  color: ${colors.pureWhite};
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: 500ms;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ${media.tablet} {
    ${text.tablet.button}
  }
`

const Wrapper = styled.div`
  position: relative;
  cursor: pointer;

  &:hover {
    ${Path} {
      fill: ${colors.pureWhite};
    }

    ${Content} {
      color: ${colors.pureBlack};
    }
  }  

  width: 10.42vw;
  height: 3.13vw;

  ${media.tablet} {
    width: 14.65vw;
    height: 4.39vw;
  }
`